import { useState } from 'react';
import { Modes } from '@constants/canvas/layers';
import { doesTabSupportPartners } from '@constants/entities/project-dashboard';
import { ProjectToolBox, ProjectViews } from '@context/Project/types';
import { useProjectDashboardActions } from '@store/zustand/project-dashboard-filters';
import { BehaviorSubject } from 'rxjs';

export const modeSubject = new BehaviorSubject<Modes | null>(null);

const useToolbox = () => {
  const { resetMaturityView } = useProjectDashboardActions();
  const [toolbox, setToolbox] = useState<ProjectToolBox>({
    mode: null,
    view: ProjectViews.Model,
  });

  const changeToolbox = (newToolbox: Partial<ProjectToolBox>) => {
    setToolbox((prev) => ({ ...prev, ...newToolbox }));
  };

  const handleViewChange = (view: ProjectViews) => changeToolbox({ view });

  const handleModeChange = (mode: Modes | null) => {
    changeToolbox({ mode });
    modeSubject.next(mode);

    if (!doesTabSupportPartners(mode, 0)) {
      resetMaturityView();
    }
  };

  return {
    toolbox,
    handleViewChange,
    handleModeChange,
  };
};

export default useToolbox;
